import AutomatedMessages from './AutomatedMessages';

export default AutomatedMessages;
